import React from "react";

export default function NavBar() {
  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 backdrop-blur-md bg-[rgba(5,5,5,0.6)] border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-14 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="font-display font-black tracking-tight text-sm md:text-base uppercase"
        >
          Alex<span className="text-[var(--accent-primary)]">.</span>Moore
        </a>

        <nav className="hidden md:flex items-center gap-8 font-mono text-[11px] uppercase tracking-[0.2em] text-white/60">
          <a href="#showreel" className="link-underline hover:text-white" data-testid="nav-showreel">
            Showreel
          </a>
          <a href="#group" className="link-underline hover:text-white" data-testid="nav-group">
            The Group
          </a>
          <a href="#experience" className="link-underline hover:text-white" data-testid="nav-experience">
            Experience
          </a>
          <a href="#skills" className="link-underline hover:text-white" data-testid="nav-skills">
            Skills
          </a>
          <a href="#contact" className="link-underline hover:text-white" data-testid="nav-contact">
            Contact
          </a>
        </nav>

        <a
          href="mailto:alex@weddingvideo.co.uk"
          data-testid="nav-email-cta"
          className="hidden md:inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] px-3 py-2 border border-white/20 hover:border-white/60 transition-colors"
        >
          <span className="inline-block w-1.5 h-1.5 rounded-full bg-[var(--accent-primary)] rec-dot" />
          Hire&nbsp;Alex
        </a>
      </div>
    </header>
  );
}
